class ReiandoHeader {
  constructor(header) {
    this.header = header;
    this.toggle = header.querySelector('[data-reiando-menu-toggle]');
    this.menu = header.querySelector('[data-reiando-mobile-menu]');

    if (!this.toggle || !this.menu) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);

    this.toggle.addEventListener('click', this.handleToggle);
    document.addEventListener('keydown', this.handleKeydown);
    this.menu.addEventListener('click', this.handleMenuClick);
  }

  handleToggle() {
    const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.setAttribute('aria-label', 'メニューを閉じる');
    this.menu.hidden = false;

    document.body.classList.add('reiando-menu-open');
  }

  close() {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.setAttribute('aria-label', 'メニューを開く');
    this.menu.hidden = true;

    document.body.classList.remove('reiando-menu-open');
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  handleMenuClick(event) {
    const link = event.target.closest('a');

    if (link) {
      this.close();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-reiando-header]')
    .forEach((header) => new ReiandoHeader(header));
});

document.addEventListener('shopify:section:load', (event) => {
  const header = event.target.querySelector('[data-reiando-header]');

  if (header) {
    new ReiandoHeader(header);
  }
});